import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FilterPickerToggleComponent } from './filter-picker-toggle.component';

@NgModule({
  declarations: [
    FilterPickerToggleComponent
  ],
  imports: [
    CommonModule,
    MatButtonModule,
    MatIconModule,
    MatTooltipModule
  ],
  exports: [
    FilterPickerToggleComponent
  ]
})
export class FilterPickerToggleModule { }
